import _ from 'lodash'

import diffUtil from '../util/diff.util'
import jotUtil from '../util/jot.util'
import {SYNC_IGNORE_KEYS} from '../index.reducer'
import {socketQueueCommand} from './socket.action'


const TIMEOUT = 500
let timer = null

let queuedJots = []
let reversalJots = []
let queueJots = (jots, reverse) => {
    queuedJots = queuedJots.concat(_.castArray(jots))
    reversalJots = reversalJots.concat(_.castArray(reverse))
}

const doDispatch = (store, socket, revision, clientId) => {
    let op = jotUtil.toList(queuedJots)
    let reverseOp = jotUtil.toList(reversalJots)

    let action = socketQueueCommand(
        socket,
        op,
        reverseOp,
        revision,
        clientId
    )

    store.dispatch(action)

    console.log('SOCKET DISPATCH ->', action)

    queuedJots = []
    reversalJots = []
    timer = null
}


export const StateChange = {
    build: (currentState, nextState) => {
    // this has to follow a different flow from store.subscribe, store.dispatch
    // or it will trigger an infinite loop
    // see http://redux.js.org/docs/api/Store.html#subscribelistener

        if (currentState === nextState) {
            // nothing to see here, move along
            return null
        }

        let diff = diffUtil.onChange(currentState, nextState, SYNC_IGNORE_KEYS)

        if (diff && diff.length > 0) {
            return jotUtil.fromDiff(diff, _.identity)
        }

        return null
    },

    dispatch: function(store, socket, jots, reverseJots, revision, clientId) {
        queueJots(jots, reverseJots)

        if (timer !== null) {
            clearTimeout(timer)
        }

        timer = setTimeout(function () {
            doDispatch(store, socket, revision, clientId)
        }, TIMEOUT)
    }
}
